import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import type { FC } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { ServiceType } from 'src/interfaces/new-channel-partner/channelPartner';
import { serviceMasterApi } from 'src/api/serviceType';
import { ResponseCodes } from 'src/enums/responseCodes';
import { PaginationAndFilter } from 'src/interfaces/common/pagination';
import { Status } from 'src/enums/common';
import { ChevronLeft as ChevronLeftIcon } from '../../../../../icons/chevron-left';
import { ChevronDown as ChevronDownIcon } from '../../../../../icons/chevron-down';
import { Scrollbar } from '../../../../scrollbar';

interface ServiceTypeProps {
  cpServiceTypes: ServiceType[];
}

export const ServiceInfoCard: FC<ServiceTypeProps> = (props) => {
  const { cpServiceTypes } = props;
  const [finalServices, setFinalServices] = useState<ServiceType[]>([]);
  const [displayBankInfo, setDisplayBankInfo] = useState<boolean>(true);

  const getAllServices = async () => {
    const paginationObject: PaginationAndFilter = {
      filters: [
        {
          property: 'status',
          operator: 'in',
          value: [
            Status.PUBLISH,
          ],
        },
      ],
      pageSize: 99,
      pageNumber: 1,
      sort: -1,
      sortBy: ''
    };
    const serviceResponse = await serviceMasterApi.getServiceByPaginationAndFilters(
      paginationObject
    );
    if (serviceResponse.statusCode === ResponseCodes.OK) {
      setFinalServices(cpServiceTypes);
    }
  };

  useEffect(() => {
    getAllServices().catch(console.error);
  }, [cpServiceTypes]);

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          mt: 1
        }}
      >
        <CardHeader
          titleTypographyProps={{ variant: 'h2' }}
          title="Services"
          action={(
            <>
              { cpServiceTypes?.length > 0 && (
                <>
                  { displayBankInfo && (
                  <IconButton
                    aria-label="view"
                    onClick={() => {
                      setDisplayBankInfo(false);
                    }}
                  >
                    <ChevronDownIcon />
                  </IconButton>
                  )}
                  { !displayBankInfo && (
                  <IconButton
                    aria-label="view"
                    onClick={() => {
                      setDisplayBankInfo(true);
                    }}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  )}
                </ >
              )}
            </>
          )}
        />
        {displayBankInfo && (
          <>
            {cpServiceTypes?.length > 0 && (
            <CardContent>
              <Grid
                container
                spacing={1}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                  sm={12}
                >
                  <Card
                    variant="outlined"
                  >
                    <Scrollbar>
                      <TableContainer
                        sx={{
                          maxHeight: '220px',
                        }}
                      >
                        <Table
                          size="small"
                          stickyHeader
                          aria-label="sticky table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                width="10%"
                                sx={{
                                  backgroundColor: 'neutral.100',
                                }}
                              >
                                SERVICE ID
                              </TableCell>
                              <TableCell
                                width="40%"
                                sx={{
                                  backgroundColor: 'neutral.100',
                                }}
                              >
                                TYPE
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {finalServices?.map((service) => (
                              <TableRow
                                key={service.id}
                              >
                                <TableCell>
                                  {service.id}
                                </TableCell>
                                <TableCell>
                                  {service.type}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
            )}
          </ >
        )}
      </Card>
    </>
  );
};

ServiceInfoCard.propTypes = {
  cpServiceTypes: PropTypes.array,
};
